import { render } from "./Loading.vue?vue&type=template&id=48915955"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=48915955&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__